<template>
  <template v-if="model_list.length == 1 && model_list && model_list[0]">
    <div class="model_info">
      <div class="report_section_basic_info_car_pic">
        <img :src="model_list[0].model_img" />
      </div>
      <CarInfoTable :car_info="model_list[0]" />
      <div class="add_model" v-if="levelVal == 0" @click="changeModel(null)">
        对比车型
      </div>
    </div>
    <NodeName
      v-if="levelVal == 0"
      :node_name="tab_select == 1
          ? '性能指标得分'
          : tab_select == 2
          ? '功能指标得分'
          : tab_select == 3
          ? '旅途指标得分'
          : tab_select == 4
          ? '创新指标得分'
          : ''"
    />
  </template>
  <!-- :height="level <= 1 ? 'calc(100vh - 253px)' : 'calc(100vh - 153px)'" -->
  <!-- <el-scrollbar
      width="auto"
      noresize
      
      @scroll="scrollFn"
    > -->
  <div :style="'width:' + [1091, 1088, 1302][model_list.length - 1] + 'px;'">
    <div class="model_list" ref="modelListDom" v-if="model_list.length > 1">
      <div
        class="model_list_item model_list_attr"
        :style="'width:' + [554, 460, 460][model_list.length - 1] + 'px;'"
      >
        车型信息
      </div>
      <template v-if="model_list && model_list.length > 0">
        <template v-for="(item, index) in model_list" :key="index">
          <div
            class="model_list_item model_list_model"
            :style="'width:' + [337, 214, 214][model_list.length - 1] + 'px;'"
          >
            <!-- <div class="model_img" v-show="!topFold">
              <img :src="item.model_img || ''" alt="图片加载失败" />
            </div> -->
            <div class="model_name">
              {{ item.brand + " " + item.model_name }}
            </div>
            <!-- <div
              v-if="item.model_id != query_model_id"
              class="change_model cursor_pointer"
              @click="changeModel(item.model_id)"
              v-show="!topFold"
            >
              换车型
            </div> -->
            <div
              v-if="item.model_id != query_model_id"
              class="del_model cursor_pointer"
              @click="delModel(item.model_id)"
            ></div>
          </div>
        </template>
      </template>
      <div class="model_list_item model_list_empty" style="width: 200px">
        <div
          class="ext_btn add_compare_btn flex_center flex_col"
          @click="changeModel(null)"
          v-if="model_list && model_list.length > 0 && model_list.length < 3"
        >
          <i class="sprite_icon icon_add"></i>
          <div>添加车型</div>
        </div>
      </div>
    </div>
    <!-- :style="{
            'min-height': 'calc(100vh - 300px)',
            hegiht: '200px',
            width: [1091, 1088, 1302][model_list.length - 1] + 'px',
          }" -->
    <el-table
      empty-text="暂无数据,敬请期待。"
      v-loading="loading"
      element-loading-text="计算得分中..."
      :data="render_list"
      :style="{
        width: [1091, 1088, 1302][model_list.length - 1] + 'px',
      }"
      row-key="node_id"
      border
      :default-expand-all="true"
      :tree-props="{ children: 'child' }"
      :span-method="objectSpanMethod"
    >
      <el-table-column
        :resizable="false"
        label="评测项"
        :width="[554, 460, 460][model_list.length - 1]"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span
            class="level_tag"
            v-if="
              tab_select == 4
                ? scope.row.node_id < 4 && scope.row.node_id > 0
                : scope.row.is_leaf == 0 &&
                  scope.row.level > 0 &&
                  scope.row.level < 4
            "
            :style="{
              background:
                tab_select == 4
                  ? '#649FEB'
                  : ['#649FEB', '#65C57C', '#F29D65'][scope.row.level - 1],
            }"
          >
            {{
              tab_select == 4
                ? "创新类型"
                : ["一", "二", "三", "四", "五", "六"][scope.row.level - 1] +
                  "级评测项"
            }}
          </span>
          <span>
            {{ scope.row.node_name || scope.row.name }}
          </span>

          <!--
              <el-popover :tabindex="-1" v-if="Object.keys(scope.row.child).length == 0" placement="right" :width="400" trigger="hover">
                <div class="rulePop">{{scope.row.node_desc}}</div>
                <template #reference>
                  <span class="tip_icon" @mouseenter="getRule(scope.row)"></span>
                </template>
              </el-popover>
              -->
          <el-popover
            v-if="
              scope.row.child &&
              Object.keys(scope.row.child).length == 0 &&
              tab_select != 4
            "
            :tabindex="-1"
            placement="right"
            :width="400"
            trigger="hover"
          >
            <div class="rulePop">{{ scope.row.node_desc }}</div>
            <template #reference>
              <span class="tip_icon" @mouseenter="getRule(scope.row)"></span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <template v-if="model_list && model_list.length > 0">
        <template v-for="(item, index) in model_list" :key="index">
          <el-table-column
            :resizable="false"
            label="得分"
            :width="[337, 214, 214][model_list.length - 1]"
          >
            <template #default="scope">
              <template
                v-if="
                  scope.row.score[index] > -1 &&
                  scope.row.total_score[index] > 0 &&
                  (scope.row.node_id < 4
                    ? scope.row.name.indexOf('创新') == -1
                    : true)
                "
              >
                <tree-table-item
                  :data="{
                    type: 2,
                    score: scope.row.score[index],
                    total_score: scope.row.total_score[index],
                  }"
                ></tree-table-item>
              </template>

              <template
                v-else-if="
                  scope.row.node_id < 4 && scope.row.name.indexOf('创新') > -1
                "
              >
                <tree-table-item
                  :data="{
                    type: 4,
                    score: scope.row.score[index],
                    total_score: scope.row.total_score[index],
                  }"
                ></tree-table-item>
              </template>
              <!-- <template v-else>
                    <div style="text-align:center">-</div>
                  </template> -->
            </template>
          </el-table-column>
        </template>
      </template>

      <el-table-column
        :resizable="false"
        label="详情"
        width="200"
        class-name="td_class"
      >
        <template #default="scope">
          <template v-if="tab_select == 4">
            <span
              class="detail_tag"
              v-if="!scope.row.child"
              @click="getInnovateDetailV2Info(scope.row)"
            >
              专家评价
            </span>
          </template>
          <template v-else-if="scope.row.is_leaf == 0">
            <!-- <span
              class="appraise_one_tag"
              v-if="scope.row.level == 1"
              @click="getEvaluation(scope.row, '专家综合评价')"
            >
              专家综合评价
            </span>
            <span
              class="appraise_two_tag"
              v-else-if="scope.row.level == 2"
              @click="getEvaluation(scope.row, '专家评价')"
            >
              专家评价
            </span>
            <span v-else> </span> -->
            <span></span>
          </template>
          <span
            class="detail_tag"
            v-else
            @click="
              getDetail(scope.row);
              showRuleDesc = false;
            "
          >
            详情
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <!-- </el-scrollbar> -->

  <el-drawer
    v-model="dialogVisible"
    :title="node_name"
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="my_dialog" v-if="dialogVisible">
      <table class="detail_table" border="1">
        <tr class="detail_title">
          <td class="detail_attr">车型</td>
          <template v-for="(item, ind) in model_list" :key="ind">
            <td class="detail_title_item" colspan="1">
              {{ item.brand + " " + item.model_name }}
            </td>
          </template>
        </tr>

        <tr class="detail_tr_item">
          <td class="detail_attr">
            <div>得分</div>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <div class="attr_box">
                <div class="attr_node_score">
                  <span class="attr_node_score_num" style="color:#f00"
                    >{{ (item["1"] && item["1"].item_value_val) || 0 }}分</span
                  >
                </div>
              </div>
            </td>
          </template>
        </tr>

        <tr class="detail_tr_item" v-show="showRuleDesc == true">
          <td class="detail_attr">
            标准
            <span
              v-if="detail_list.length > 1"
              id="triangle-up"
              @click="showRuleDesc = false"
            ></span>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <div
                class="detail_val_text"
                v-html="(item['9'] && item['9']) || '暂无'"
              ></div>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <!-- 背景色占位 -->
        </tr>
        <tr class="detail_tr_item" v-show="showRuleDesc == false">
          <td class="detail_attr">
            标准
            <span id="triangle-down" @click="showRuleDesc = true"></span>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  padding: 5px;
                "
                class="detail_val_text"
                v-html="(item['9'] && item['9']) || '暂无'"
              ></div>
            </td>
          </template>
        </tr>

        <tr class="detail_tr_item">
          <td class="detail_attr">主观评价</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <div
                class="detail_val_text"
                v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
              ></div>
            </td>
          </template>
        </tr>
        <!-- <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr> -->
        <tr class="detail_tr_item">
          <td class="detail_attr">图片素材</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item['4'] && item['4'].ext_info.length > 0">
                <div
                  class="detail_val_pic"
                >
                  <div
                    class="detail_pic_left"
                    @click.stop="
                      previewImg(item['4'] && item['4'].ext_info, 'img')
                    "
                  >
                    <div class="detail_pic_left_img">
                      <img
                        :src="item['4'].ext_info[0].attach_value || ''"
                        alt="图片加载失败"
                      />
                      <span class="more_pic">{{
                        item["4"] && item["4"].ext_info.length
                      }}</span>
                    </div>
                    <div class="look_pic">点击查看图片</div>
                  </div>
                  <div
                    class="detail_pic_right detail_val_text"
                    v-if="item['4'] && item['4'].item_value_val"
                    v-html="item['4'] && item['4'].item_value_val"
                  ></div>
                </div>
                <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['4'] && item['4'].ext_info,model_list[ind].model_name,node_name)"></div>
              </template>
              <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <td class="detail_attr">视频素材</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item['5'] && item['5'].ext_info.length > 0">
                <div
                  class="detail_val_video"
                >
                  <div
                    class="detail_video_left"
                    @click.stop="
                      previewImg(item['5'] && item['5'].ext_info, 'video')
                    "
                  >
                    <div class="detail_pic_left_video">
                      <video controlsList="nodownload" :src="item['5'].ext_info[0].attach_value"
                      :poster="item['5'].ext_info[0].attach_value+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                      preload="none"
                      ></video>
                      <span class="more_pic">{{
                        item["5"] && item["5"].ext_info.length
                      }}</span>
                    </div>
                    <div class="look_pic">点击查看视频</div>
                  </div>
                  <div
                    class="detail_pic_right detail_val_text"
                    v-if="item['5'] && item['5'].item_value_val"
                    v-html="item['5'] && item['5'].item_value_val"
                  ></div>
                </div>
                <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['5'] && item['5'].ext_info,model_list[ind].model_name,node_name)"></div>
              </template>
              <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </el-drawer>

  <el-drawer
    v-model="drawer"
    :title="innovate_detail_list_cur_type"
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="my_dialog">
      <table class="detail_table2">
        <tr class="table_tit">
          <td
            class="table_tit_item"
            v-if="!(model_list.length == 1 || innovate_detail_list.length == 1)"
          >
            车型信息
          </td>
          <!-- <td class="table_tit_item">对应二级功能指标</td>
          <td class="table_tit_item">创新分类</td> -->
          <td class="table_tit_item">创新项目</td>
          <td class="table_tit_item">创新维度评分</td>
          <td class="table_tit_item">综合得分</td>
          <td class="table_tit_item">图片素材</td>
          <td class="table_tit_item">视频素材</td>
          <td class="table_tit_item">创新项目主观评价</td>
        </tr>

        <template
          v-for="(list_item, list_ind) in innovate_detail_list"
          :key="list_ind"
        >
          <template v-for="(item, ind) in list_item" :key="ind">
            <tr class="table_tr">
              <template v-if="item">
                <td
                  class="table_tr_td"
                  v-if="
                    !(
                      model_list.length == 1 || innovate_detail_list.length == 1
                    ) && ind == 0
                  "
                  :rowspan="list_item.length"
                >
                  <div class="td_model_info">
                    <div class="table_model_img" v-if="list_item.model_img">
                      <img
                        :src="list_item.model_img || ''"
                        alt="图片加载失败"
                      />
                    </div>
                    <div class="table_model_name">
                      {{ list_item.brand + " " + list_item.model_name }}
                    </div>
                  </div>
                </td>
                <!-- <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="item.hebing"
                  :rowspan="item.hebing"
                >
                  <div class="td_node_two td_text_bold">
                    {{ item.review_tree_name || "" }}
                  </div>
                </td>
                <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="list_ind == innovate_first_key && ind == 0"
                  rowspan="999"
                >
                  <div class="td_node_two td_text_bold">
                    {{innovate_detail_list_cur_type}}
                  </div>
                </td> -->
                <td class="table_tr_td">
                  <div class="td_node_name td_text_bold">
                    {{ item.node_name }}
                  </div>
                </td>
                <td class="table_tr_td">
                  <div class="td_score table_text">
                    <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                    <p>实用：{{ item.practical_score || 0 }}分</p>
                    <p>独创：{{ item.originality_score || 0 }}分</p>
                  </div>
                </td>
                <td class="table_tr_td">
                  <div class="td_score_two">
                    {{ item.synthetical_score || 0 }}分
                  </div>
                </td>
                <td class="table_tr_td detail_val">
                  <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                     <div
                      class="detail_val_pic"
                      
                    >
                      <div
                        class="detail_pic_left"
                        @click.stop="
                          previewImg(
                            item.item['3'] && item.item['3'].ext_info,
                            'img'
                          )
                        "
                      >
                        <div class="detail_pic_left_img">
                          <img
                            :src="item.item['3'].ext_info[0].attach_value || ''"
                            alt="图片加载失败"
                          />
                          <span class="more_pic">{{
                            item.item["3"] && item.item["3"].ext_info.length
                          }}</span>
                        </div>
                        <div class="look_pic">点击查看图片</div>
                      </div>
                      <div
                        class="detail_pic_right detail_val_text"
                        v-if="item.item['3'] && item.item['3'].item_value_val"
                        v-html="item.item['3'] && item.item['3'].item_value_val"
                      ></div>
                    </div>
                    <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item.item['3'] && item.item['3'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                  </template>
                  <div class="no_img" v-else>
                    当前测试子节点本次未涉及图片素材
                  </div>
                </td>
                <td class="table_tr_td detail_val">
                  <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                    <div
                      class="detail_val_video"
                    >
                      <div
                        class="detail_video_left"
                        @click.stop="
                          previewImg(
                            item.item['4'] && item.item['4'].ext_info,
                            'video'
                          )
                        "
                      >
                        <div class="detail_pic_left_video">
                          <video
                            :src="item.item['4'].ext_info[0].attach_value"
                            :poster="item.item['4'].ext_info[0].attach_value+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                            preload="none"
                          ></video>
                          <span class="more_pic">{{
                            item.item["4"] && item.item["4"].ext_info.length
                          }}</span>
                        </div>
                        <div class="look_pic">点击查看视频</div>
                      </div>
                      <div
                        class="detail_pic_right detail_val_text"
                        v-if="item.item['4'] && item.item['4'].item_value_val"
                        v-html="item.item['4'] && item.item['4'].item_value_val"
                      ></div>
                    </div>
                    <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item.item['4'] && item.item['4'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                  </template>
                  <div class="no_img" v-else>
                    当前测试子节点本次未涉及视频素材
                  </div>
                </td>

                <td class="table_tr_td">
                  <div class="td_evaluation table_text">
                    <template v-for="(p_item, p_ind) in item.item" :key="p_ind">
                      <p
                        v-if="
                          p_item.item_value_val &&
                          p_item.item_value_type != 4 &&
                          p_item.item_value_type != 5
                        "
                        v-html="p_item.item_value_val"
                      ></p>
                    </template>
                  </div>
                </td>
              </template>
            </tr>
          </template>
        </template>
      </table>
    </div>
  </el-drawer>

  <el-drawer
    v-model="descDrawer"
    title=""
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="one_evaluation_desc" v-if="evaluation_list.length == 1">
      <div class="one_desc_tit">
        {{ evaluation_list[0].node_name }}-专家综合评价
      </div>
      <div
        class="one_desc_desc"
        v-html="evaluation_list[0].node_value.content"
      ></div>
    </div>
    <div class="more_evaluation_desc" v-else>
      <table class="table3">
        <tr>
          <td v-for="(item, ind) in model_list" :key="ind">
            <div class="table3_model_name">
              {{ item.brand + " " + item.model_name }}专家综合评价
            </div>
          </td>
        </tr>
        <tr>
          <td
            class="table_bd_left"
            v-for="(item, ind) in model_list"
            :key="ind"
          >
            <div class="table_title_text">评价主体</div>
          </td>
        </tr>
        <tr>
          <td
            class="table_bd_left"
            v-for="(item, ind) in model_list"
            :key="ind"
          >
            <div class="table3_model_desc">
              <div
                class="table3_model_content"
                v-if="evaluation_list[ind].node_value.content"
                v-html="evaluation_list[ind].node_value.content"
              ></div>
              <div
                class="table3_model_experts"
                v-if="evaluation_list[ind].node_value.evaluator"
              >
                评价专家:{{ evaluation_list[ind].node_value.evaluator }}
              </div>
              <div
                class="table3_model_time"
                v-if="evaluation_list[ind].node_value.evaluate_time"
              >
                {{
                  timestampToString(
                    evaluation_list[ind].node_value.evaluate_time
                  )
                }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </el-drawer>

  <div class="my_swiper_dialog" v-if="swiperVisible">
    <div class="my_swiper_dialog_content">
      <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
      <swiper :list="preview_list" :type="preview_type" />
    </div>
  </div>
  <el-backtop
    target=".el-main"
    :visibility-height="500"
    :right="50"
    :bottom="50"
  />
</template>

<script>
import {
  getEnergyType,
  timestampToString,
} from "@/components/common/js/common.js";
import { ref } from "@vue/reactivity";
import {
  ElTable,
  ElTableColumn,
  // ElProgress,
  // ElScrollbar,
  ElBacktop,
  ElDrawer,
  ElPopover,
  ElMessage
} from "element-plus";
import Swiper from "@/components/swiper/Swiper.vue";
// import store from "@/store/index"
import {
  getCarScoreInnovateV2,
  getTestDetailV2,
  getInnovateDetailV2,
  getCarSummaryDataV2,
} from "@/api";
import { watch } from "vue-demi";
import { useRouter } from "vue-router";
// import { computed } from "vue";
import store from "@/store";
import TreeTableItem from "@/components/common/views/treeTable/TreeTableItem.vue";
import CarInfoTable from "@/components/common/views/carInfoTable.vue";
import NodeName from "@/components/common/views/NodeName.vue";
export default {
  name: "Evaluation",
  components: {
    NodeName,
    ElTable,
    ElTableColumn,
    // ElProgress,
    // ElScrollbar,
    ElBacktop,
    ElDrawer,
    Swiper,
    ElPopover,
    TreeTableItem,
    CarInfoTable,
  },
  setup() {
    const model_list = ref([]);
    const loading = ref(false);
    const tab_select = ref(1);
    const showRuleDesc = ref(true);
    const tab_list = ref([
      {
        name: "性能对比",
        node_id: 1,
      },
      {
        name: "功能对比",
        node_id: 2,
      },
      {
        name: "旅途场景对比",
        node_id: 3,
      },
      {
        name: "创新项目对比",
        node_id: 4,
      },
    ]);
    const router = useRouter();
    const queryData = router.currentRoute.value.query;
    let {
      node_id = 1,
      model_id,
      model_ids = "[]",
    } = queryData;

    // const contrastListRef = computed(() => store.state.compareCarDataV2);
    const query_model_id = ref(model_id);
    const levelVal = ref(0);
    const nodeId = ref(0);
    nodeId.value = node_id;

    let getModelInfo = (ids) => {
      let promise_list1 = ids.map((id) => {
        return new Promise((resolve, reject) => {
          getCarSummaryDataV2({
            model_id: id,
            get_base: 1,
          })
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            reject();
          });
        });
      });
      Promise.all(promise_list1).then((res_list) => {
        model_list.value = res_list.map((res) => {
          return res.data;
        });
        getScoreTree();
      });
    };
    getModelInfo([model_id,...JSON.parse(model_ids)]);
    // type有值就是创新项
    tab_select.value = 4;
   

    // 目前是只有创新的一级评测项切换的时候才会变nodeId
    watch(nodeId, (new_val, old_val) => {
      if (new_val != old_val) {
        getScoreTree();
      }
    });

    // 合并后树表格列表
    const render_list = ref([]);
    const getScoreTree = () => {
      render_list.value = [];
      loading.value = true;
      let promise_list = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          let reqParams = {
            report_id: item.report_id,
            model_id: item.model_id,
            type:0,
            need_own:1
          };
          console.log(nodeId.value)
          getCarScoreInnovateV2(reqParams).then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        });
      });
      Promise.all(promise_list).then((res_list) => {
        if (tab_select.value == 4) {
          var list = hebing(
            res_list.map((res) => {
              return res.data;
            }),
            true
          );
          list.forEach((childs) => {
            childs.child &&
              childs.child.forEach((child_item) => {
                if (Object.keys(child_item.child).length > 0) {
                  child_item.child = chenggenb(
                    child_item.child,
                    child_item["name"]
                  );
                }
              });
          });
          if (list.length < 1) {
            list = [
              {
                child: [],
                name:
                  nodeId.value == 1
                    ? "行车域创新"
                    : nodeId.value == 2
                    ? "泊车域创新"
                    : "领航辅助创新",
                node_id: nodeId.value,
                score: {},
                total_score: {},
              },
            ];
          }
          render_list.value = list;
        } else {
          render_list.value = hebing(
            res_list.map((res) => {
              return res.data.list;
            })
          );
        }

        loading.value = false;
      });
    };

    function chenggenb(list, parent_name) {
      console.log(list);

      let set_ind = 0,
        set_arr = [],
        col_ind = 0;
      list = JSON.parse(JSON.stringify(list));
      list.forEach((row_item, row_ind) => {
        for (let i = 0; i < model_list.value.length; i++) {
          if (row_item.score[i] > -1) {
            //如果有分数，并且和上一次的col_ind相等，就往set_arr里面push(row_item.node_id),
            //          不相等的话，就改变col_ind的值 并且重置新的set_arr= [row_item.node_id];
            //              当前下标小于col_ind 说明要重置新的set_arr= [row_item.node_id]
            if (i != col_ind) {
              list[set_ind]["set_arr"] = set_arr;
              list[set_ind]["parent_name"] = parent_name;
              set_arr = [];
              set_arr.push(row_item.node_id);
              set_ind = row_ind;
              col_ind = i;
              break;
            } else {
              set_arr.push(row_item.node_id);
              break;
            }
          }
          if (!(row_item.score[i] > -1) && i == model_list.value.length - 1) {
            list[set_ind]["set_arr"] = set_arr;
            list[set_ind]["parent_name"] = parent_name;
            set_arr = [];
            set_ind = row_ind;
            col_ind = -1;
          }
        }
        if (row_ind == list.length - 1) {
          list[set_ind]["set_arr"] = set_arr;
          list[set_ind]["parent_name"] = parent_name;
        }
      });
      return list;
    }

    // getScoreTree();
    watch(tab_select, (new_val, old_val) => {
      if (new_val != old_val) {
        getScoreTree();
      }
    });
    // 详情弹窗数据展示列表
    const detail_list = ref([]);
    // 详情弹窗当前节点名字
    const node_name = ref("");

    // 详情弹窗控制
    const dialogVisible = ref(false);

    //获取详情数据
    const getDetail = (row) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
    
      let promise_list2 = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        detail_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data && res.data.item_value) {
            res.data.item_value.forEach((item) => {
              item_value[item.item_value_val_type] = item;
            });
            item_value["9"] = res.data["node_desc"];
          }
          return item_value;
        });
        console.log(detail_list.value);
        dialogVisible.value = true;
      });
    };
    // 创新数据列表
    const innovate_detail_list = ref([]);
    const innovate_detail_list_cur_type = ref("");
    const innovate_first_key = ref(0);
    //获取创新项目详情数据
    const getInnovateDetailV2Info = (row) => {
      innovate_detail_list_cur_type.value = row.parent_name;
      let node_id = row.set_arr.join("-") || row.id;
      let promise_list3 = model_list.value.map((item) => {
        console.log(item);
        return new Promise((resolve, reject) => {
          getInnovateDetailV2({
            // report_id:5,
            report_id: item.report_id,
            // model_id:277,
            model_id: item.model_id,
            node_ids: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list3).then((res_list) => {
        let set_ind = 0;
        let set_add = 1;
        let prev_review_tree_name = "";
        innovate_detail_list.value = res_list.map((res, ind) => {
          let item_value = {};
          if (res.data && res.data.length) {
            item_value = res.data;
            item_value.brand = model_list.value[ind].brand;
            item_value.model_name = model_list.value[ind].model_name;
            item_value.model_id = model_list.value[ind].model_id;
            item_value.model_img = model_list.value[ind].model_img;
            res.data = res.data.map((item, index) => {
              let item_item_val = {};
              item.item.forEach((item_item) => {
                item_item_val[item_item.item_value_type] = item_item;
              });
              item.item = item_item_val;
              if (item.review_tree_name != prev_review_tree_name) {
                prev_review_tree_name = item.review_tree_name;
                res.data[set_ind].hebing = set_add;
                set_ind = index;
                set_add = 1;
              } else {
                item.hebing = 0;
                set_add++;
              }
              return item;
            });
            res.data[set_ind].hebing = set_add;
          } else {
            item_value = null;
          }
          return item_value;
        });
        for (let key in innovate_detail_list.value) {
          if (innovate_detail_list.value[key] != null) {
            innovate_first_key.value = key;
            break;
          }
        }

        drawer.value = true;
        // dialogVisible.value= true;
      });
    };

    const swiperVisible = ref(false);
    const preview_list = ref([]);
    const preview_type = ref("img");
    const previewImg = (list, type) => {
      preview_list.value = list;
      preview_type.value = type;
      swiperVisible.value = true;
    };

    const drawer = ref(false);
    const handleClose = (done) => {
      done();
    };

    const descDrawer = ref(false);
    const evaluation_type = ref("");
    const evaluation_list = ref([]);
    const getEvaluation = (row, type) => {
      evaluation_type.value = type;
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
     
      let promise_list2 = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        evaluation_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data) {
            item_value = {
              node_name: res.data.node_name,
              node_value: res.data.node_value,
            };
          }
          // if(res.data && res.data.item_value){
          //     res.data.item_value.forEach((item)=>{
          //         item_value[item.item_value_val_type] = item;
          //     })
          // }
          return item_value;
        });
        descDrawer.value = true;
      });
    };

    const closeSwiperDialog = () => {
      document.querySelectorAll("video").forEach((item) => {
        item.pause();
      });
      swiperVisible.value = false;
    };

    const topFold = ref(false);
    const modelListDom = ref(null);

    const scrollFn = ({ scrollTop }) => {
      if (modelListDom.value) {
        if (scrollTop > modelListDom.value.offsetHeight) {
          topFold.value = true;
        } else {
          topFold.value = false;
        }
      }
    };

    const objectSpanMethod = ({ row, columnIndex }) => {
      if (columnIndex === model_list.value.length + 1) {
        if (!("child" in row)) {
          if (row.set_arr && row.set_arr.length) {
            return {
              rowspan: row.set_arr.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 1,
            };
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    };

    let changeModel = (model_id) => {
      if (model_id) {
        router.push({
          path: "/v2/report/change_model",
          query: {
            not_in_id: [router.currentRoute.value.query.model_id,...JSON.parse(router.currentRoute.value.query.model_ids)].join(","),
            model_id,
          },
        });
      } else {
        router.push({
          path: "/v2/report/change_model",
          query: {
            not_in_id: [router.currentRoute.value.query.model_id,...JSON.parse(router.currentRoute.value.query.model_ids)].join(","),
          },
        });
      }
    };
    let delModel = (model_id) => {
      let model_ids = [];
      let new_model_ids = [];
      model_ids = [router.currentRoute.value.query.model_id,...JSON.parse(router.currentRoute.value.query.model_ids)];
      model_ids.forEach((item) => {
        if (item != model_id) {
          new_model_ids.push(item);
        }
      });
      let cur_path = router.currentRoute.value.path;
      router.replace({
        path: cur_path,
        query: {
          ...queryData,
          model_ids: JSON.stringify(new_model_ids),
        },
      });

      getModelInfo(new_model_ids);
    };

    const getRule = (row) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
          .then((res) => {
            row.node_desc = res.data.node_desc;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        });
      });
    };

    const downloadFn = (list,model_name,node_name)=>{
      store.addDownload(list,model_name,node_name);
      ElMessage.success("已添加到下载队列中")
    }
    return {
      query_model_id,
      getRule,
      levelVal,
      dialogVisible,
      loading,
      tab_select,
      tab_list,
      model_list,
      node_name,
      render_list,
      detail_list,
      getDetail,
      getInnovateDetailV2Info,
      innovate_detail_list,
      preview_list,
      preview_type,
      previewImg,
      swiperVisible,
      drawer,
      handleClose,
      descDrawer,
      getEvaluation,
      evaluation_list,
      timestampToString,
      closeSwiperDialog,
      scrollFn,
      topFold,
      modelListDom,
      // modelInfo,
      // modelInfoList,
      getEnergyType,
      objectSpanMethod,
      changeModel,
      delModel,
      // innovate_tab_id,
      // change_innovate_id,
      showRuleDesc,
      innovate_detail_list_cur_type,
      innovate_first_key,
      
      downloadFn,
      store
    };
  },
};
// 获取地址栏数据
// function GetUrlParam(url) {
//   let arrObj = url.split("?");
//   let params = Object.create(null);
//   if (arrObj.length > 1) {
//       arrObj = arrObj[1].split("&");
//       arrObj.forEach(item => {
//           item = item.split("=");
//           params[item[0]] = item[1]
//       })
//   }
//   return params;
// }
/*---------合并树数据---------*/
let scoreMap = {},
  childMap = {},
  nodeMap = {},
  count = 0;
function hebing(data, is_cx) {
  count = data.length;
  let listMap = {};
  for (let k in data) {
    let list = data[k];
    for (let dd in list) {
      let d = JSON.parse(JSON.stringify(list[dd]));
      listMap[d["node_id"]] = mapList(d, k);
      setScoreMap(d["node_id"], d["total_score"], d["score"], k);
      nodeMap[d["node_id"]] = d;
    }
  }
  let tmpList = [];
  Object.values(listMap).forEach((l) => {
    l["total_score"] = fillArray(scoreMap[l["node_id"]]["total_score"]);
    l["score"] = fillArray(scoreMap[l["node_id"]]["score"]);
    tmpList.push(l);
  });
  let tree_list = rebuild(tmpList);
  scoreMap = {};
  childMap = {};
  nodeMap = {};
  count = 0;

  if (!is_cx) {
    let newMap = {};
    let result_list = [];
    for (let ti in tree_list) {
      newMap[tree_list[ti]["node_id"]] = tree_list[ti];
    }
    for (let di in data[0]) {
      result_list.push(newMap[data[0][di]["node_id"]]);
    }
    return result_list;
  } else {
    return tree_list;
  }
}
function rebuild(list) {
  let exitsArr = {};
  let newArr = Array();
  for (let key in list) {
    let l = list[key];
    if (!exitsArr[l["node_id"]]) {
      exitsArr[l["node_id"]] = true;
      if (childMap[l["node_id"]]) {
        console.log(l['node_id'], childMap)
        let childList = [];
        for (let ckey in childMap[l["node_id"]]) {
          let c = childMap[l["node_id"]][ckey];
          let child = nodeMap[c];
          child["total_score"] = fillArray(
            scoreMap[child["node_id"]]["total_score"]
          );
          child["score"] = fillArray(scoreMap[child["node_id"]]["score"]);
          childList.push(child);
        }
        l["child"] = rebuild(childList);
      }
      newArr.push(l);
    }
  }
  return newArr;
}
function fillArray(arr) {
  for (let i = 0; i < count; i++) {
    if (typeof arr[i] == "undefined") {
      arr[i] = -1;
    }
  }
  return arr;
}
function mapList(list2, k) {
  let childlist2 = list2["child"];
  if (!childlist2) {
    return;
  }
  list2["child"] = {};
  if (childlist2.length > 0 || Object.keys(childlist2).length > 0) {
    for (let k1 in childlist2) {
      let child = childlist2[k1];
      if (
        !childMap[list2["node_id"]] ||
        childMap[list2["node_id"]].indexOf(child["node_id"]) == -1
      ) {
        if (!childMap[list2["node_id"]]) {
          childMap[list2["node_id"]] = [];
        }
        childMap[list2["node_id"]].push(child["node_id"]);
      }
      setScoreMap(child["node_id"], child["total_score"], child["score"], k);
      list2["child"] = {};
      list2["child"][child["node_id"] + ""] = mapList(child, k);
      nodeMap[child["node_id"]] = child;
    }
  } else {
    setScoreMap(list2["node_id"], list2["total_score"], list2["score"], k);
  }
  return list2;
}
function setScoreMap(node_id, total_score, score, k) {
  if (!scoreMap[node_id]) {
    scoreMap[node_id] = {};
  }
  if (!scoreMap[node_id]["total_score"]) {
    scoreMap[node_id]["total_score"] = {};
  }
  if (!scoreMap[node_id]["score"]) {
    scoreMap[node_id]["score"] = {};
  }
  scoreMap[node_id]["total_score"][k] = total_score;
  scoreMap[node_id]["score"][k] = score;
}
/*---------合并树数据---------*/
</script>
<style>
.el-popover.el-popper {
  background: #ffffff;
  box-shadow: 0px 1px 9px 0px rgba(107, 148, 199, 0.5);
  border-radius: 8px;
}
</style>
<style lang="less" scoped>
#triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid;
}
#triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid;
}
.rulePop {
  white-space: break-spaces;
  padding: 10px;
  font-size: 12px;
  line-height: 22px;
}
.model_info {
  width: 1090px;
  background: #ffffff;
  border-radius: 4px;
  // border: 1px solid #e8edfd;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .report_section_basic_info_car_pic {
     width:180px;
    height:98px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .add_model {
    width: 88px;
    height: 87px;
    background: #ffffff
      url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/f2f136912832b378f45e1ff5bfbe7ca0.png)
      no-repeat center center;
    background-size: 25px;
    background-position-y: 25px;
    // box-shadow: 0px 0px 7px 0px #bcd8ff;
    border-radius: 12px;
    line-height: 140px;
    font-size: 15px;
    color: #7e7e7e;
    text-align: center;
    flex-shrink: 0;
    margin-left: 20px;
    color: #709ae8;
    cursor: pointer;
  }
}
.model_info_title {
  width: 1090px;
  height: 66px;
  line-height: 66px;
  // background: #ffffff;
  // border-radius: 13px;
  // border: 1px solid #e8edfd;
  padding-left: 28px;
  font-size: 18px;
  font-weight: bold;
  color: #474747;
  position: relative;
}
.model_info_title::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 18px;
  background: #46d4f7;
  border-radius: 1px;
  top: 24px;
  left: 0px;
}

.tabs {
  display: flex;
  .tab_item {
    min-width: 142px;
    padding: 0 30px;
    text-align: center;
    height: 43px;
    line-height: 43px;
    background: #ecf2ff;
    border-radius: 6px;
    border: 1px solid #b4c3ed;
    font-size: 16px;
    color: #474747;
    margin-right: 17px;
    cursor: pointer;
    &.active {
      background: #ffffff;
      font-weight: bold;
    }
  }
}
.el-scrollbar {
  /* margin-top: 26px;*/
}
.model_list {
  margin-bottom: 16px;
  display: flex;
  position: sticky;
  top: -16px;
  background: #fff;
  border-radius: 13px;
  border: 1px solid #e8edfd;
  z-index: 1;
  .model_list_item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 80px;
    &.model_list_attr {
      font-size: 18px;
      color: #979797;
    }
    .model_img {
      height: 50px;
      width: auto;
      img {
        height: 100%;
        width: auto;
      }
    }
    .model_name {
      padding: 0 20px;
      font-size: 14px;
      font-weight: bold;
      color: #474747;
      line-height: 19px;
    }
    .change_model {
      margin-top: 10px;
      width: 75px;
      height: 20px;
      line-height: 20px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #979797;
      font-size: 14px;
      color: #979797;
      text-align: center;
    }
    .del_model {
      width: 30px;
      height: 30px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/4a3586a9dfb5b8adff5da214b317daaa.png)
        no-repeat center center;
      background-size: 50%;
      position: absolute;
      right: 5px;
      top: 0;
      cursor: pointer;
    }
  }
}

.level_tag {
  display: inline-block;
  width: 83px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  margin: 0 10px;
}
.tip_icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c33656821a1100392efd965678caf39d.png)
    no-repeat center bottom;
  background-size: 17px 17px;
  margin-left: 10px;
}
.appraise_one_tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #dde5fd;
  font-size: 14px;
  color: #474747;
  cursor: pointer;
  position: absolute;
}
.appraise_two_tag,
.detail_tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #709ae8;
  cursor: pointer;
  position: absolute;
}
:deep(.el-table__row > td:last-child) {
  height: 40px;
  padding: 0 0;
  .cell {
    padding: 10px;
    width: 100%;
    height: 100%;
    line-height: 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
:deep(.el-table__body-wrapper) {
  overflow: visible;
}

:deep(.el-table th) {
  text-align: center;
}
:deep(.el-dialog) {
  // width:auto !important;
  max-width: 80vw;
  max-height: 70vh;
  margin: auto;
  overflow-y: auto;
  .el-dialog__body {
    overflow-x: auto;
  }
}


.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}

.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
        no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      cursor: pointer;
      z-index: 2;
    }
  }
}

.detail_table2 {
  border-collapse: collapse;
  tr {
    background: #fff;
    td {
      border: 1px solid #dee6f2;
      text-align: center;
      padding: 10px;
    }
  }

  .table_tit {
    td {
      height: 44px;
    }
  }
  .td_model_info {
    width: 130px;
    .table_model_img {
      width: 100%;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .table_model_name {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #474747;
      line-height: 16px;
    }
  }
  .td_node_name {
    width: 100px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_score {
    width: 110px;
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
  .td_score_two {
    width: 80px;
    font-size: 12px;
    color: #578ae9;
  }
  .td_node_two {
    width: 105px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_evaluation {
    max-width: 480px;
    text-align: left;
    white-space: pre-line;
    p {
      padding: 10px;
      font-size: 12px;
      color: #777c89;
      line-height: 16px;
    }
  }
}

.one_evaluation_desc {
  max-width: 600px;
  min-width: 480px;
  padding: 0 50px;

  .one_desc_tit {
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    color: #2b2b2b;
  }
  .one_desc_desc {
    font-size: 18px;
    font-weight: 400;
    color: #777c89;
    line-height: 30px;
  }
}
.more_evaluation_desc {
  padding: 0 10px;
  .table3 {
    border-collapse: collapse;
    td {
      &.table_bd_left {
        border-left: 1px solid #dee6f2;
        &:first-child {
          border: none;
        }
      }
      & > div {
        width: 350px;
        text-align: center;
      }
      .table3_model_name {
        height: 90px;
        font-size: 16px;
        font-weight: bold;
        color: #474747;
        line-height: 24px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .table_title_text {
        height: 32px;
        background: #f5f8fc;
        font-size: 12px;
        font-weight: bold;
        color: #474747;
        line-height: 32px;
      }
      .table3_model_desc {
        padding: 40px 30px 10px;
        font-size: 14px;
        color: #777c89;
        line-height: 20px;
        .table3_model_content {
          text-align: left;
          white-space: pre-line;
        }
        .table3_model_experts,
        .table3_model_time {
          text-align: right;
          margin-top: 12px;
        }
      }
    }
  }
}

:deep(.el-dialog) {
  width: auto;
  height: auto;
  max-width: 99vw;
  max-height: 99vh;
  margin: 0;
}

:deep(.modal_transparent) {
  background: transparent;
}

:deep(.el-drawer__body) {
  overflow-y: auto;
}
:deep(.el-progress-bar__innerText) {
  color: #000;
}

.table_tr_td_hebing {
  background: #fff;
}

.ext_btn {
  width: 80px;
  height: 80px;
  div {
    font-size: 14px;
    margin-top: 10px;
    color: #709ae8;
  }
  cursor: pointer;
}
.color_E7816E {
  color: #e7816e;
}

</style>